export enum IdentifierType {
	ALADDIN_ID = 'ALADDIN_ID',
	aladdinId = 'aladdinId',
	ALADDIN_SHARE_CLASS_TICKER = 'ALADDIN_SHARE_CLASS_TICKER',
	ALADDIN_TICKER = 'ALADDIN_TICKER',
	APIR_CODE = 'APIR_CODE',
	BB_ID_COMPOSITE = 'BB_ID_COMPOSITE',
	BB_ID_GLOBAL = 'BB_ID_GLOBAL',
	BB_ID_SHARE_CLASS = 'BB_ID_SHARE_CLASS',
	BB_ID_UNIQUE = 'BB_ID_UNIQUE',
	BCUSIP = 'BCUSIP',
	bCusip = 'bCusip',
	BLOOMBERG_ID = 'BLOOMBERG_ID',
	BLOOMBERG_TICKER = 'BLOOMBERG_TICKER',
	CLASS_GLOBAL_ID = 'CLASS_GLOBAL_ID',
	CUSIP = 'CUSIP',
	cusip = 'cusip',
	CUSTOM = 'CUSTOM',
	EXCHANGE_SYMBOL = 'EXCHANGE_SYMBOL',
	GLOBAL_ID = 'GLOBAL_ID',
	globalId = 'globalId',
	INVARIANT_ID = 'INVARIANT_ID',
	ISIN = 'ISIN',
	isin = 'isin',
	ISSUER_ID = 'ISSUER_ID',
	LISTING_GLOBAL_ID = 'LISTING_GLOBAL_ID',
	MORNINGSTAR_SEC_ID = 'MORNINGSTAR_SEC_ID',
	morningstarSecId = 'morningstarSecId',
	MORNINGSTAR_FUND_ID = 'MORNINGSTAR_FUND_ID',
	morningstarFundId = 'morningstarFundId',
	multiple = 'multiple',
	PORTFOLIO_CODE = 'PORTFOLIO_CODE',
	PORTFOLIO_ID = 'PORTFOLIO_ID',
	MODEL_ID = 'MODEL_ID',
	QUASAR_FUND_ID = 'QUASAR_FUND_ID',
	QUASAR_PORT_ID = 'QUASAR_PORT_ID',
	RISK_CUSIP = 'RISK_CUSIP',
	SECURITY_ID = 'SECURITY_ID',
	securityId = 'securityId',
	SEDOL = 'SEDOL',
	sedol = 'sedol',
	THIRD_PARTY_ID = 'THIRD_PARTY_ID',
	TICKER = 'TICKER',
	ticker = 'ticker',
	UNIQUE_ID = 'UNIQUE_ID',
	UNKNOWN = 'UNKNOWN',
	'unknown' = 'unknown'
}
